export function onEventEnterPressed(event: React.KeyboardEvent<any>) {
  if (event.key === "Enter") {
    return true;
  }

  return false;
}
